import { axios } from 'lib/axios';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';
import { queryClient } from 'lib/react-query';

export const changeTransactionStatus = ({ data }) => {
  return axios.patch('/transaction/status', data);
};

export const useChangeTransactionStatus = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async () => {},
    onError: (_, __, context) => {},
    onSuccess: (data) => {
      queryClient.invalidateQueries(['transactions']);
      addNotification({
        type: 'success',
        title: 'Status updated successfully',
      });
    },
    ...config,
    mutationFn: changeTransactionStatus,
  });
};
